import { MobileHeader } from '@/components/mobile-shell/MobileHeader';
import { EmptyState } from '@/components/feedback';
import { ListRow } from '@/components/banking';
import { resolveContext } from '@/state/session';
import { customerActivity } from '@/services/audit';
import { formatDateTime } from '@/services/formatters';

/**
 * Customer-visible activity feed.
 *
 * TRACE:TT-R126-02 — the all-activity view renders activity records, or an
 * explicit empty state, never a blank screen.
 *
 * This reads the customer projection of the audit log, so internal fields
 * (before/after values, permission used, operator notes) can never leak to the
 * customer surface.
 */
export function ActivityPage() {
  const resolved = resolveContext();
  const events = resolved ? customerActivity(resolved.company.id) : [];

  return (
    <>
      <MobileHeader title="Activity" backTo="/mobile/more" backLabel="More" />
      <div className="tm-stack">
        <p className="tm-muted">
          A record of actions taken on this account, newest first.
        </p>

        {events.length === 0 ? (
          <EmptyState
            title="No activity yet"
            body="When you or your team make changes — payments, card controls, access changes — they will be listed here."
          />
        ) : (
          <div className="tm-card tm-card--flush">
            <ul className="tm-rows">
              {events.map((event) => (
                <li key={event.id}>
                  <ListRow
                    title={event.summary}
                    meta={`${event.actorName} · ${formatDateTime(event.createdAt)}`}
                  />
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </>
  );
}
